module.exports = __webpack_public_path__ + "img/FL.1879099d.webp";